import { WeightedTable } from "./WeightedTable";
import type { LevelConfig } from "./LevelConfig";
import { Difficulty } from "../difficulty/DifficultyTuning";

/**
 * Draft campaign tuning (1..10). These are just data — no gameplay wiring yet.
 * Goal: 1000 points per level.
 */
export const LEVEL_CONFIGS: LevelConfig[] = [
  {
    id: 1,
    name: "Hatchling",
    goalScore: 1000,
    difficulty: Difficulty.easy(),
    foodWeights: new WeightedTable([
      { item: "RED", weight: 1 },
    ]),
    enemies: ["NONE"],
    flags: { lasers: false },
  },
  {
    id: 2,
    name: "Greed Mode",
    goalScore: 1000,
    difficulty: { ...Difficulty.easy(), snakeSpeedMul: 1.05, maxFoodOnBoard: 3 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.75 },
      { item: "GOLD", weight: 0.25 },
    ]),
    enemies: ["NONE"],
    flags: { lasers: false },
  },
  {
    id: 3,
    name: "Laser License",
    goalScore: 1000,
    difficulty: Difficulty.medium(),
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.6 },
      { item: "GOLD", weight: 0.2 },
      { item: "PURPLE_LASER", weight: 0.2 },
    ]),
    enemies: ["NONE"],
    flags: { lasers: true, triple: false, lightning: false },
  },
  {
    id: 4,
    name: "Cold Snap",
    goalScore: 1000,
    difficulty: { ...Difficulty.medium(), enemyPressure: 0.35 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.5 },
      { item: "GOLD", weight: 0.2 },
      { item: "PURPLE_LASER", weight: 0.15 },
      { item: "BLUE_ICE", weight: 0.15 },
    ]),
    enemies: ["SCAVENGER"],
    flags: { lasers: true },
  },
  {
    id: 5,
    name: "Arena",
    goalScore: 1000,
    difficulty: { ...Difficulty.hard(), enemyPressure: 0.55 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.45 },
      { item: "GOLD", weight: 0.2 },
      { item: "PURPLE_LASER", weight: 0.2 },
      { item: "BLUE_ICE", weight: 0.15 },
    ]),
    enemies: ["SCAVENGER"],
    flags: { lasers: true },
  },
  {
    id: 6,
    name: "Star Rush",
    goalScore: 1000,
    difficulty: { ...Difficulty.hard(), maxFoodOnBoard: 5, enemyPressure: 0.65 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.35 },
      { item: "GOLD", weight: 0.2 },
      { item: "PURPLE_LASER", weight: 0.2 },
      { item: "BLUE_ICE", weight: 0.1 },
      { item: "STAR_TRIPLE", weight: 0.15 },
    ]),
    enemies: ["SCAVENGER"],
    flags: { lasers: true, triple: true },
  },
  {
    id: 7,
    name: "Frostbite",
    goalScore: 1000,
    difficulty: { ...Difficulty.insane(), enemyPressure: 0.75 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.3 },
      { item: "GOLD", weight: 0.15 },
      { item: "PURPLE_LASER", weight: 0.2 },
      { item: "BLUE_ICE", weight: 0.15 },
      { item: "STAR_TRIPLE", weight: 0.2 },
    ]),
    enemies: ["SCAVENGER"],
    flags: { lasers: true, triple: true },
  },
  {
    id: 8,
    name: "Crossfire",
    goalScore: 1000,
    difficulty: { ...Difficulty.insane(), enemyPressure: 0.9 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.25 },
      { item: "GOLD", weight: 0.15 },
      { item: "PURPLE_LASER", weight: 0.2 },
      { item: "STAR_TRIPLE", weight: 0.25 },
      { item: "ICY_LIGHTNING", weight: 0.15 },
    ]),
    enemies: ["SCAVENGER", "HUNTER"],
    flags: { lasers: true, triple: true, lightning: true },
  },
  {
    id: 9,
    name: "Thunder Run",
    goalScore: 1000,
    difficulty: { ...Difficulty.insane(), snakeSpeedMul: 1.75, enemyPressure: 1.0 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.2 },
      { item: "GOLD", weight: 0.1 },
      { item: "PURPLE_LASER", weight: 0.2 },
      { item: "STAR_TRIPLE", weight: 0.25 },
      { item: "ICY_LIGHTNING", weight: 0.25 },
    ]),
    enemies: ["HUNTER"],
    flags: { lasers: true, triple: true, lightning: true },
  },
  {
    id: 10,
    name: "Boss Royale",
    goalScore: 1000,
    difficulty: { ...Difficulty.insane(), snakeSpeedMul: 1.9, foodSpawnEveryMs: 380, maxFoodOnBoard: 6, enemyPressure: 1.2 },
    foodWeights: new WeightedTable([
      { item: "RED", weight: 0.18 },
      { item: "GOLD", weight: 0.1 },
      { item: "PURPLE_LASER", weight: 0.18 },
      { item: "STAR_TRIPLE", weight: 0.27 },
      { item: "ICY_LIGHTNING", weight: 0.27 },
    ]),
    enemies: ["BOSS", "HUNTER"],
    flags: { lasers: true, triple: true, lightning: true, boss: true },
  },
];
